import ChartMixin from "@/components/Charts/mixins/bar-chart";

export default {
	name: "DeliveryNotesUnsignedProductMatchChart",

	mixins: [ ChartMixin ],

	props: {
		item: Object,
		items: Array
	},

	data: () => ( {
		averageObjectValuePath: "stats.numUnsignedProductMatchFields",
		title: "Unsigned Product Match Fields",
		yAxisLabel: "Missing Signatures (Count)"
	} ),

	computed: {
		barData() {
			if ( this.item ) {
				return [
					this.item.stats.numUnsignedProductMatchFields,
					this.averageValue
				];
			}

			return this.items.map( item => item.stats.numUnsignedProductMatchFields );
		},

		labels() {
			if ( this.item ) {
				return [
					this.item.driver.user.name.split( " " ),
					[ "All drivers", "average" ]
				];
			}

			return this.items.map( item => item.driver.user.name.split( " " ) );
		}
	}
};
